/**
 * @generated SignedSource<<7b094659bc2a93eca72fcc05bcdf459c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Projects$data = {
  readonly jira: {
    readonly canCreateProject: boolean | null | undefined;
    readonly hasIsProjectsExpanded?: "JiraQuery";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectsForLanding">;
  readonly " $fragmentType": "Nav4Projects";
};
export type Nav4Projects$key = {
  readonly " $data"?: Nav4Projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Projects">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isProjectsExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Projects",
  "selections": [
    {
      "condition": "isProjectsExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4ProjectsForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isProjectsExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsProjectsExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "alias": "canCreateProject",
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "CREATE_PROJECT"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "a555601eac0ae7ffe20da1e2ae68ce09";

export default node;
